import React from 'react';
import QRPreview from '../shared/QRPreview';

const MobileQRTab = ({ propertyTab, portfolio }) => {
  return <QRPreview variant="mobile" propertyTab={propertyTab} portfolio={portfolio} />;
};

export default MobileQRTab;
